export enum BackOfficeSettingsRouteEnum {
  MAIN = "back-office-settings",
}
